var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "dropdown__wrapper", attrs: { id: "login-change" } },
    [
      _vm.isLoggedIn
        ? _c("span", { staticClass: "dropdown" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("span", { staticClass: "dropdown-menu dropdown-menu-right" }, [
              _c(
                "span",
                {
                  staticClass: "user-login__cta-wrapper",
                  attrs: { "aria-labelledby": "accountMenuList" },
                },
                [
                  _c("span", { staticClass: "user-login__name" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.$translate(
                            "ODFashioncode::Fashioncode.loginMyAccountWelcome"
                          )
                        ) +
                        " " +
                        _vm._s(_vm.username) +
                        _vm._s(
                          _vm.$translate(
                            "ODFashioncode::Fashioncode.loginMyAccountWelcomeEM"
                          )
                        ) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      directives: [{ name: "logout", rawName: "v-logout" }],
                      staticClass: "user-login__cta user-login__cta--logout",
                      attrs: { href: "#" },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$translate("Ceres::Template.loginLogout")
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "user-login__sepperator" }),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "user-login__cta user-login__cta--block",
                      attrs: { href: _vm.$ceres.urls.myAccount },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$translate("Ceres::Template.loginMyAccount")
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "user-login__cta user-login__cta--block",
                      attrs: { href: _vm.$ceres.urls.myAccount },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$translate(
                              "ODFashioncode::Fashioncode.loginMyAccountOrders"
                            )
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "user-login__cta user-login__cta--block",
                      attrs: { href: _vm.$ceres.urls.myAccount },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$translate(
                              "ODFashioncode::Fashioncode.loginMyAccountRetoure"
                            )
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "user-login__cta user-login__cta--block",
                      attrs: { href: _vm.$ceres.urls.myAccount },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$translate(
                              "ODFashioncode::Fashioncode.loginMyAccountHelp"
                            )
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    { name: "close-dropdown", rawName: "v-close-dropdown" },
                  ],
                  staticClass: "user-login__close",
                },
                [
                  _c("svg", { attrs: { width: "20", height: "20" } }, [
                    _c("use", {
                      attrs: {
                        "xmlns:xlink": "http://www.w3.org/1999/xlink",
                        "xlink:href": "#svg-close",
                      },
                    }),
                  ]),
                ]
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoggedIn
        ? _c("span", { staticClass: "dropdown" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("span", { staticClass: "dropdown-menu dropdown-menu-right" }, [
              _c(
                "span",
                {
                  staticClass: "user-login__cta-wrapper",
                  attrs: { "aria-labelledby": "accountMenuListTwo" },
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "user-login__cta user-login__cta--pipe",
                      attrs: {
                        "data-toggle": "modal",
                        "data-target": "#id--login-modal",
                        href: "javascript:void(0)",
                      },
                      on: {
                        click: function ($event) {
                          _vm.createLoginModal()
                          _vm.unmarkInputFields()
                        },
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$translate("Ceres::Template.login")) +
                            "\n                    "
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "user-login__cta",
                      attrs: {
                        href: _vm.isLogin
                          ? "javascript:void(0)"
                          : _vm.$ceres.urls.registration,
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.$translate("Ceres::Template.loginRegister")
                            ) +
                            "\n                    "
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "user-login__sepperator" }),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "user-login__cta user-login__cta--block",
                      attrs: { href: _vm.$ceres.urls.myAccount },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$translate("Ceres::Template.loginMyAccount")
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "user-login__cta user-login__cta--block",
                      attrs: { href: _vm.$ceres.urls.myAccount },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$translate(
                              "ODFashioncode::Fashioncode.loginMyAccountOrders"
                            )
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "user-login__cta user-login__cta--block",
                      attrs: { href: _vm.$ceres.urls.myAccount },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$translate(
                              "ODFashioncode::Fashioncode.loginMyAccountRetoure"
                            )
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "user-login__cta user-login__cta--block",
                      attrs: { href: _vm.$ceres.urls.myAccount },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$translate(
                              "ODFashioncode::Fashioncode.loginMyAccountHelp"
                            )
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    { name: "close-dropdown", rawName: "v-close-dropdown" },
                  ],
                  staticClass: "user-login__close",
                },
                [
                  _c("svg", { attrs: { width: "20", height: "20" } }, [
                    _c("use", {
                      attrs: {
                        "xmlns:xlink": "http://www.w3.org/1999/xlink",
                        "xlink:href": "#svg-close",
                      },
                    }),
                  ]),
                ]
              ),
            ]),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "dropdown-toggle shop-nav__btn",
        attrs: {
          href: "#",
          id: "accountMenuList",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false",
        },
      },
      [_c("i", { staticClass: "icon__user", attrs: { "aria-hidden": "true" } })]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "dropdown-toggle shop-nav__btn",
        attrs: {
          href: "#",
          id: "accountMenuListTwo",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false",
        },
      },
      [_c("i", { staticClass: "icon__user", attrs: { "aria-hidden": "true" } })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }